/* 早見表 */
.eraTableContainer {
  width: 100%;
  margin-top: 1rem;
  overflow: hidden;
  border-radius: var(--border-radius);
  background: white;
  box-shadow: var(--shadow-md);
}

.eraTable {
  background: white;
  border-radius: var(--border-radius);
  overflow: hidden;
}

.tableHeader {
  background-color: var(--primary-light);
  color: var(--primary-dark);
  font-weight: 600;
  padding: 1rem;
  margin: 0;
  font-size: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
  display: flex;
  align-items: center;
}

.continuousYearsWrapper {
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  padding: 0.5rem;
  white-space: nowrap;
  scrollbar-width: thin;
  scrollbar-color: var(--primary-light) transparent;
}

/* Webkit系ブラウザ用のスクロールバー */
.continuousYearsWrapper::-webkit-scrollbar {
  height: 8px;
}

.continuousYearsWrapper::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.continuousYearsWrapper::-webkit-scrollbar-thumb {
  background-color: var(--primary-light);
  border-radius: 4px;
  border: 2px solid white;
}

.continuousYearsWrapper::-webkit-scrollbar-thumb:hover {
  background-color: var(--primary-color);
}

/* 情報アイコン */
.infoIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--primary-dark);
  color: white;
  font-size: 0.75rem;
  font-weight: bold;
  margin-left: 0.5rem;
  cursor: pointer;
  position: relative;
}

.tooltipContent {
  display: none;
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  background: white;
  box-shadow: var(--shadow-md);
  border-radius: var(--border-radius);
  padding: 1rem;
  width: 250px;
  z-index: 100;
  font-weight: normal;
  text-align: left;
  font-size: 0.85rem;
}

.tooltipVisible {
  display: block;
}

.tooltipContent h5 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: var(--primary-dark);
}

.tooltipItem {
  margin-bottom: 0.3rem;
  font-size: 0.8rem;
}

/* 連続表示テーブル */
.continuousEraTable {
  border-collapse: collapse;
  font-size: 0.85rem;
  white-space: nowrap;
  width: auto;
}

/* 年ペアのセル */
.yearPair {
  padding: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
  position: relative;
}

.yearPairInner {
  display: flex;
  align-items: center;
}

/* セルホバー効果 */
.yearPair:hover {
  background-color: rgba(52, 82, 165, 0.12);
}

/* 元号年のスパン */
.eraYear {
  display: inline-block;
  text-align: right;
  padding: 0.35rem 0.5rem 0.35rem 0.25rem;
  width: 50px;
  border-right: 1px dashed rgba(0, 0, 0, 0.1);
}

/* 西暦年のスパン */
.westernYear {
  display: inline-block;
  text-align: left;
  padding: 0.35rem 0.25rem 0.35rem 0.5rem;
  width: 45px;
}

/* グループ区切り線 */
.groupBorder {
  position: absolute;
  top: 0;
  right: 0;
  width: 2px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.15);
}

/* 現在の年のハイライト */
.yearPair.currentYear {
  background-color: rgba(52, 82, 165, 0.08);
}

.currentYear .eraYear,
.currentYear .westernYear {
  font-weight: 700;
  color: var(--primary-color);
}

/* 元号切り替わり年のスタイル */
.overlapYear {
  position: relative;
}

.dualEraDisplay {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  text-align: center;
}

.dualEraDisplay div {
  color: inherit;
  font-weight: inherit;
}

/* アニメーション */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (min-width: 768px) {
  .continuousEraTable {
    font-size: 0.9rem;
  }
  
  .eraYear {
    width: 60px;
  }
  
  .westernYear {
    width: 50px;
  }
}

/* ダークモード対応 - グローバル変数を使用 */
@media (prefers-color-scheme: dark) {
  .eraTableContainer,
  .eraTable {
    background-color: var(--dark-bg-secondary, #1e1e1e);
    border: 1px solid var(--dark-border, #3c4043);
  }
  
  .tableHeader {
    background-color: var(--dark-surface, #242424);
    color: var(--primary-color, #7bb3ff);
    border-bottom-color: var(--dark-border, #3c4043);
  }
  
  .tooltipContent {
    background-color: var(--dark-bg-secondary, #1e1e1e);
    border: 1px solid var(--dark-border, #3c4043);
    color: var(--dark-text, #e1e3e6);
  }
  
  .tooltipContent h5 {
    color: var(--primary-color, #7bb3ff);
  }
  
  .yearPair:hover {
    background-color: rgba(123, 179, 255, 0.12);
  }
  
  .yearPair.currentYear {
    background-color: rgba(123, 179, 255, 0.15);
  }
  
  .currentYear .eraYear,
  .currentYear .westernYear {
    color: var(--primary-color, #7bb3ff);
  }
  
  .continuousYearsWrapper::-webkit-scrollbar-track {
    background: var(--dark-bg-tertiary, #2d2d2d);
  }
  
  .continuousYearsWrapper::-webkit-scrollbar-thumb {
    background-color: var(--dark-border, #3c4043);
    border-color: var(--dark-bg-secondary, #1e1e1e);
  }
  
  .continuousYearsWrapper::-webkit-scrollbar-thumb:hover {
    background-color: var(--primary-color, #7bb3ff);
  }
} 